<form class="form" (ngSubmit)="onSubmit()">
  <div class="form-group">
    <input type="text" class="form-control" name="title" [(ngModel)]="title" placeholder="Title" />
  </div>
  <div class="form-group">
    <input type="text" class="form-control" name="isbn" [(ngModel)]="isbn" placeholder="ISBN" />
  </div>
  <div class="form-group">
    <input
      type="text"
      class="form-control" 
      name="author"
      [(ngModel)]="author"
      placeholder="Author"
    />
  </div>
  <div class="form-group">
    <input
      type="text"
      class="form-control" 
      name="description"
      [(ngModel)]="description"
      placeholder="Description"
    />
  </div>
  <div class="form-group">
    <input
      type="date"
      class="form-control" 
      name="published_date"
      [(ngModel)]="published_date"
      placeholder="Published Date"
    />
  </div>
  <div class="form-group">
    <input
      type="text"
      class="form-control" 
      name="publisher"
      [(ngModel)]="publisher"
      placeholder="Publisher"
    />
  </div>
  <div class="form-group">
    <input
      type="date"
      class="form-control" 
      name="updated_date"
      [(ngModel)]="updated_date"
      placeholder="Updated Date"
    />
  </div>
  <input type="submit" value="Submit" class="btn btn-dark btn-primary btn-lg btn-block" />
</form>
